exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.language[data-v-4f09812a]{\n    float: right;\n}\nselect[data-v-4f09812a]{\n    text-transform: uppercase;\n}\n", ""]);

// exports
